import React from "react";

export const NoFilter = () => null;